export default "__VITE_ASSET__CEOBwRMG__"